/**
 * @generated SignedSource<<04ea739d1f4c36cb215a8176fe56e3cc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView$data = {
  readonly fieldOption: {
    readonly color: {
      readonly colorKey: string | null | undefined;
    } | null | undefined;
    readonly value: string | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView";
};
export type singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView$key = {
  readonly " $data"?: singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "fieldOption",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "value"
        },
        {
          "concreteType": "JiraColor",
          "kind": "LinkedField",
          "name": "color",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "colorKey"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraSingleSelectField"
};

(node as any).hash = "1276308a1838194b7b78528c304458c7";

export default node;
